import { useContext } from "react";

import { ContentWrapper, Text } from "@crunchyroll/cx-web-components";

import LanguageSelect from "../LanguageSelect";

import { ThemeContext } from "../../../context/themecontext";
import { ASSETS_BUILD_PATH } from "../../../constants/staticUrls";

import styles from "./footerCopyrightSection.module.scss";

const FooterCopyrightSection = () => {
  const theme = useContext(ThemeContext).value;
  const backgroundImageTheme = theme === "dark" ? "light" : "dark";
  const backgroundImage = `${ASSETS_BUILD_PATH}/img/footer/sony_pictures_logo_${backgroundImageTheme}.png`;

  return (
    <ContentWrapper className={styles.footerContent}>
      <div className={styles.legalWrapper}>
        <img className={styles.footerLogo} src={backgroundImage} />
        <Text className={styles.copyright} as="p" size="m">
          &copy; Crunchyroll, LLC
        </Text>
      </div>
      <LanguageSelect className={styles.language} />
    </ContentWrapper>
  );
};

export default FooterCopyrightSection;
